import React from 'react'
import  { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { GradientText } from '../PasserCommande/PasserCommande.styles';
import Container from '../../Components/LayoutClient/container.component';
import { getClientStats } from '../../api/clients';
import Chart from 'react-apexcharts';
import { BarChart2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

function ClientStats() {
    const { _id } = useSelector((state) => state.auth.user);
    const token = useSelector((state) => state.auth.token);
    const [chargementEnCours, setChargementEnCours] = useState(false);
    const [data, setData] = useState(null);
    const {t} = useTranslation();
    const handleFilterChange = async () => {
        setChargementEnCours(true);
        try {
            const response = await getClientStats(_id, token);
            console.log("response",response)
            setData(response);
        } catch (error) {
            console.error('Erreur lors de la récupération des statistiques:', error);
        } finally {
            setChargementEnCours(false);
        }
    };

    useEffect(() => {
        handleFilterChange();
    }, [_id, token]);

    const hasStats =
    (data?.caMensuel?.length || 0) > 0 ||
    (data?.caRemboursement?.length || 0) > 0 ||
    (data?.caRemboursementEnCours?.length || 0) > 0 ||
    (data?.caRemboursementEchoue?.length || 0) > 0 ||
    (data?.stats?.[0]?.globalStats?.length || 0) > 0;

    const combinedLabels = Array.from(
        new Set([
            ...(data?.caMensuel || []).map(item => `${item._id.mois}/${item._id.annee}`),
            ...(data?.caRemboursement || []).map(item => `${item._id.mois}/${item._id.annee}`),
            ...(data?.caRemboursementEnCours || []).map(item => `${item._id.mois}/${item._id.annee}`),
            ...(data?.caRemboursementEchoue || []).map(item => `${item._id.mois}/${item._id.annee}`),

        ])
    );

    const pieOptions = {
        chart: {
            type: 'pie'
        },
        labels: [t("in_progress"), t("not_started"), t("cancelled"), t("completed")],
        colors: ['#36A2EB', '#FFCE56', '#F44336', '#60a656'],
        legend: {
            position: 'bottom'
        },
        title: {
            text: t("order_distribution_by_status"),
            align: 'center',
            style: {
                fontSize: '16px',
                fontWeight: 'bold'
            }
        }
    };
    const pieOptionsPayment = {
        chart: {
            type: 'pie'
        },
        labels: [t("paid"), t("unpaid")],
        colors: ['#60a656', '#F44336'],
        legend: {
            position: 'bottom'
        },
        title: {
            text: t("order_distribution_by_status"),
            align: 'center',
            style: {
                fontSize: '16px',
                fontWeight: 'bold'
            }
        }
    };
    const pieSeriesPayment = [
        data?.stats?.[0]?.globalStats?.[0]?.totalPayerCount || 0,
        data?.stats?.[0]?.globalStats?.[0]?.totalNonPayerCount || 0
      ]; 
    const pieSeries = [
        data?.stats[0]?.globalStats[0]?.totalDemarrerCount || 0,
        data?.stats[0]?.globalStats[0]?.totalNonDemarrerCount || 0,
        data?.stats[0]?.globalStats[0]?.totalAnnulerCount || 0,
        data?.stats[0]?.globalStats[0]?.totalTerminerCount || 0
    ];

    const barOptions = {
        chart: {
            type: 'bar',
            toolbar: {
                show: false
            }
        },
        xaxis: {
            categories: combinedLabels,
            title: {
                text: t("month/year")
            }
        },
        yaxis: {
            title: {
                text: `${t("monthly_expenses")}s (${t("in")} euros)`
            },
            labels: {
                formatter: value => `${value} €`
            }
        },
        title: {
            text: t("monthly_expenses"),
            align: 'center',
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '50%'
            }
        },
        colors: ['#4caf50', '#2196f3','#ff9800','#F44336'],
        dataLabels: {
            enabled: false
        }
    };

    const barSeries = [
        {
            name: t("payment_expenses"),
            data: combinedLabels.map(label => {
                const item = data?.caMensuel?.find(item => `${item._id.mois}/${item._id.annee}` === label);
                return item ? item.totalCA : 0;
            })
        },
        {
            name: t("received_refund_expenses"),
            data: combinedLabels.map(label => {
                const item = data?.caRemboursement?.find(item => `${item._id.mois}/${item._id.annee}` === label);
                return item ? item.totalCA : 0;
            })
        },
        {
            name: t("pending_refund_expenses"),
            data: combinedLabels.map(label => {
                const item = data?.caRemboursementEnCours?.find(item => `${item._id.mois}/${item._id.annee}` === label);
                return item ? item.totalCA : 0;
            })
        },
        {
            name: t("failed_refund_expenses"),
            data: combinedLabels.map(label => {
                const item = data?.caRemboursementEchoue?.find(item => `${item._id.mois}/${item._id.annee}` === label);
                return item ? item.totalCA : 0;
            })
        }
    ];
    const stackedBarData = {
        series: [
            {
                name: t("in_progress"),
                data: data?.stats[0].groupedStats?.map(cmd => cmd?.demarrerCount) || [0],
                color: '#36A2EB',
            },
            {
                name: t("not_started"),
                data: data?.stats[0].groupedStats?.map(cmd => cmd?.nonDemarrerCount) || [0],
                color: '#FFCE56',
            },
            {
                name: t("cancelled"),
                data: data?.stats[0].groupedStats.map(cmd => cmd?.annulerCount) || [0],
                color: '#F44336',
            },
            {
                name: t("completed"),
                data: data?.stats[0].groupedStats?.map(cmd => cmd?.terminerCount) || [0],
                color: '#60a656',
            },
        ],
    };

    const stackedBarOptions = {
        chart: {
            type: 'bar',
            stacked: true,
            toolbar: { show: false },
        },
        plotOptions: {
            bar: {
                horizontal: false,
            },
        },
        xaxis: {
            
            categories: data?.stats[0].groupedStats?.map(item => `${item?.mois}/${item?.annee}`)|| ['Aucune donnée'],

        },
        yaxis: {
            title: {
                text: t("number_of_orders"),
            },
            labels: {
                formatter: (val) => val,
            },
        },
        title: {
            text: t("monthly_order_statistics"),
            align: 'center',
        },
        fill: {
            opacity: 1,
        },
    };
const [isSmallScreen, setSmallScreen] = useState(() => window.innerWidth < 768);


    useEffect(() => {
        const checkIfMobile = () => {
            setSmallScreen(window.innerWidth < 768);
        };
        window.addEventListener('resize', checkIfMobile);

        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
    return (
        <Container>
            <div
                style={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    paddingTop: '2rem',
                    paddingBottom: '4rem'
                }}
            >
                <GradientText style={{
                        fontSize: isSmallScreen ? '2rem' : '2.5rem'
                    }}>{t("statistics").toUpperCase()}</GradientText>
            </div>
            {chargementEnCours ?
			<div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'white',
                    marginTop:"10rem"
                }}
            >
            <div className='customLoader'></div>	
           </div>
            : hasStats ? (
            <>
            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: isSmallScreen? 'repeat(1, 1fr)' : 'repeat(4, 1fr)',
                    gap: '1rem',
                    marginBottom: '2rem',
                    width: '100%',
                    fontFamily: 'Montserrat',
                    paddingLeft: '2rem',
                    paddingRight: '2rem'
                }}
            >
                <div
                    style={{
                        backgroundColor: '#f0f0f0',
                        padding: '20px',
                        borderRadius: '10px',
                        textAlign: 'center',
                        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)'
                    }}
                >
                    <h4>{t("payment_expenses")}</h4>
                    <p>{data?.caMensuel?.reduce((sum, item) => sum + item.totalCA, 0)?.toFixed(2) || '0.00'} €</p>
                    </div>
                <div
                    style={{
                        backgroundColor: '#f0f0f0',
                        padding: '20px',
                        borderRadius: '10px',
                        textAlign: 'center',
                        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)'
                    }}
                >
                    <h4>{t("received_refund_expenses")}</h4>
                    <p>{(data?.caRemboursement?.reduce((sum, item) => sum + item.totalCA, 0))?.toFixed(2) || '0.00'} €</p>
                </div>
                <div
                    style={{
                        backgroundColor: '#f0f0f0',
                        padding: '20px',
                        borderRadius: '10px',
                        textAlign: 'center',
                        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)'
                    }}
                >
                    <h4>{t("pending_refund_expenses")}</h4>
                    <p>{(data?.caRemboursementEnCours?.reduce((sum, item) => sum + item.totalCA, 0))?.toFixed(2) || '0.00'} €</p>
                </div>
                <div
                    style={{
                        backgroundColor: '#f0f0f0',
                        padding: '20px',
                        borderRadius: '10px',
                        textAlign: 'center',
                        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)'
                    }}
                >
                    <h4>{t("failed_refund_expenses")}</h4>
                    <p>{(data?.caRemboursementEchoue?.reduce((sum, item) => sum + item.totalCA, 0))?.toFixed(2) || '0.00'} €</p>
                </div>
            </div>
            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: isSmallScreen? 'repeat(1, 1fr)' : 'repeat(2, 1fr)',
                    gap: '1rem',
                    width: '100%',
                    fontFamily: 'Montserrat',
                    paddingLeft: '2rem',
                    paddingRight: '2rem'
                }}
            >
                <div
                    style={{
                        backgroundColor: '#f0f0f0',
                        padding: '20px',
                        borderRadius: '10px',
                        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)'
                    }}
                >
                    <Chart options={pieOptions} series={pieSeries} type="pie" height={350} />
                </div>
                <div
                    style={{
                        backgroundColor: '#f0f0f0',
                        padding: '20px',
                        borderRadius: '10px',
                        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)'
                    }}
                >
                    <Chart options={pieOptionsPayment} series={pieSeriesPayment} type="pie" height={350} />
                </div>
            </div>
            <div
                style={{
                    backgroundColor: '#f0f0f0',
                    padding: '20px',
                    borderRadius: '10px',
                    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                    fontFamily: 'Montserrat',
                    marginTop: '1rem',
                    marginLeft: '2rem',
                    marginRight: '2rem',
                    
                }}
            >
                <Chart options={barOptions} series={barSeries} type="bar" height={400} />
            </div>
            {data &&
            <div
                style={{
                    backgroundColor: '#f0f0f0',
                    padding: '20px',
                    borderRadius: '10px',
                    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                    fontFamily: 'Montserrat',
                    marginTop: '1rem',
                    marginLeft: '2rem',
                    marginRight: '2rem',
                    marginBottom:'4rem'
                    
                }}
            >
                <Chart
                            options={stackedBarOptions}
                            series={stackedBarData.series}
                            type="bar"
                            height={350}
                        />
            </div>
           }
           </>
            ): (
                <div style={{ textAlign: 'center', padding: '5rem',fontFamily: 'Montserrat'               }}>
                   <BarChart2 size={64} />
                   <p style={{ marginTop: '1rem', fontSize: '18px' }}>
                     {t("no_statistics")}
                </p>
               </div>
            )}
            
        </Container>
    );
}

export default ClientStats;
